module.exports = __webpack_public_path__ + "static/media/atrapalo.c7bbf678.ico";